/** Protocol identifier for sync bootstrap messages between parent and child bridges */
export const BRIDGE_INIT_MSG = '__monei_bridge_init__';
